export default __webpack_public_path__ + "static/media/termo-inss.cf8715e4.doc";